// extracted by mini-css-extract-plugin
export default {"container":"AuthenticationPages_container__oi3aF","box":"AuthenticationPages_box__TXr87"};